import ReactFlow from 'reactflow';
import 'reactflow/dist/style.css';
import {Controls} from 'reactflow';

import axios from 'axios';

import React from 'react';

import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

import ReportBar from './reportBar';

import { apiUrl } from '..';

import { useState, useEffect, useRef } from 'react';

import { ifMobile } from '../App';


const MindMap = (Props) => {
    const reactFlowWrapper = useRef(null);

    const { goalsProp, universityRecommendationsProp, QnA } = Props;
    
    var jobLinks = {}

    var universityRecommendations = [];
    var goals = [];
    const [initialNodes, setInitialNodes] = useState([]);
    //const [initialEdges, setInitialEdges] = useState([]);
    //const [initialEdges, setInitialEdges] = useState([]);

    function tryGetJobLink(careerData, major) {
        if(!jobLinks[major]){
            axios({
                method: 'post',
                url: `${apiUrl}/get_jobs`,
                data: {
                    careerData: careerData,
                    major: major
                }
            }).then((response) => {
                jobLinks[major] = response.data.url
                window.open(jobLinks[major], '_blank');
                console.log(response.data);
            }).catch((error) => {
                console.log(error);
            });
        }
        else {
            window.open(jobLinks[major], '_blank');
        }
    }

    function AlignNodesNicely(gapX, gapY) {
        var careerNodes = document.getElementsByClassName("career");
        var universityNodes = document.getElementsByClassName("recommendation");
        var goalNodes = document.getElementsByClassName("goal");
        //const MajorGroup = document.getElementsByClassName("group")[0];
        //var totalMajorNodesWidth = 0;

        var careerNodesLnH = [];
        for (let i = 0; i < careerNodes.length; i++) {
            const currentNode = careerNodes[i].getBoundingClientRect()
            careerNodesLnH.push([currentNode.height, currentNode.width]);
        }

        var goalNodesLnH = [];
        for (let i = 0; i < goalNodes.length; i++) {
            const currentNode = goalNodes[i].getBoundingClientRect()
            goalNodesLnH.push([currentNode.height, currentNode.width]);
        }


        var universityNodesLnH = [];
        for (let i = 0; i < universityNodes.length; i++) {
            const currentNode = universityNodes[i].getBoundingClientRect()
            universityNodesLnH.push([currentNode.height, currentNode.width]);

            universityNodes[i].style.transform = "translate(" + (i * currentNode.width+(gapX*i)) + "px, 0px)";
            careerNodes[i].style.transform = "translate(" + (i * currentNode.width+(gapX*i) + (currentNode.width-careerNodesLnH[i][1])/2) + "px, " + (-careerNodesLnH[i][0]-gapY) + "px)";
            
            /*
            if(i === 1){ // this is hardcoded for now
                MajorGroup.style.transform = "translate(" + (i * currentNode.width+(gapX*i) + (currentNode.width-MajorGroup.getBoundingClientRect().width)/2) + "px, " + (currentNode.height + gapY) + "px)";
            }*/
            
            const goalDict = {0: 0, 1: 0, 2: 0};
            for (let j = 0; j < goalNodes.length; j++) {
                if(goalNodes[j].classList.contains("goal-" + i)){
                    goalDict[i] += 1;
                    goalNodes[j].style.transform = "translate(" + (i * currentNode.width+(gapX*i) + (currentNode.width-goalNodesLnH[j][1])/2) + "px, " + (currentNode.height + gapY + (goalDict[i]-1) * goalNodesLnH[j][0]) + "px)";
                }
            }
        }
    }

    const initialUniversityRecommendations = 
    [
        "**Vilnius University**\n\n**Location:** Vilnius, Lithuania\n\n**Relevant Programs Offered:**\n\n* **Bachelor's Programs:**\n    * English Philology\n    * History\n    * Art History\n    * Communication and Information Sciences\n    * Creative Writing\n* **Master's Programs:**\n    * English Studies\n    * History of Central and Eastern Europe\n    * Art History and Theory\n    * Media Studies\n    * Creative Writing and Literary Translation\n\n**Studying & Living Prices / Expenses:**\n\n**Tuition Fees:**\n\n* For Lithuanian citizens and EU/EEA students: Free\n* For international students: \u20ac4,000-\u20ac6,000 per year\n\n**Living Expenses:**\n\n* Accommodation: \u20ac200-\u20ac400 per month\n* Food: \u20ac200-\u20ac300 per month\n* Transportation: \u20ac30-\u20ac50 per month\n* Other expenses: \u20ac100-\u20ac200 per month\n\n**Other Relevant Information:**\n\n* Vilnius University is the oldest and largest university in Lithuania, founded in 1579.\n* It is a research-intensive university with a strong focus on the humanities and social sciences.\n* The university has a beautiful campus located in the heart of Vilnius, a vibrant and historic city.\n* Vilnius University offers a wide range of student support services, including academic advising, career counseling, and housing assistance.\n* The university has a strong international reputation and attracts students from all over the world.",
        "**University of Warsaw**\n\n**Location:** Warsaw, Poland\n\n**Relevant Programs Offered:**\n\n* **Bachelor's Programs:**\n    * English Studies\n    * History\n    * Art History\n    * Journalism and Social Communication\n    * Creative Writing\n* **Master's Programs:**\n    * English Studies\n    * History\n    * Art History\n    * Media Studies\n    * Creative Writing\n\n**Studying & Living Prices / Expenses:**\n\n**Tuition Fees:**\n\n* For Polish citizens and EU/EEA students: Free\n* For international students: \u20ac2,000-\u20ac3,000 per year\n\n**Living Expenses:**\n\n* Accommodation: \u20ac250-\u20ac450 per month\n* Food: \u20ac250-\u20ac350 per month\n* Transportation: \u20ac50-\u20ac70 per month\n* Other expenses: \u20ac100-\u20ac200 per month\n\n**Other Relevant Information:**\n\n* The University of Warsaw is the largest and most prestigious university in Poland, founded in 1816.\n* It is a research-intensive university with a strong focus on the humanities and social sciences.\n* The university has a beautiful campus located in the heart of Warsaw, a vibrant and historic city.\n* The University of Warsaw offers a wide range of student support services, including academic advising, career counseling, and housing assistance.\n* The university has a strong international reputation and attracts students from all over the world.",
        "**Charles University**\n\n**Location:** Prague, Czech Republic\n\n**Relevant Programs Offered:**\n\n* **Bachelor's Programs:**\n    * English and American Studies\n    * History\n    * Art History\n    * Media and Communication Studies\n    * Creative Writing\n* **Master's Programs:**\n    * English Language and Literature\n    * History\n    * Art History\n    * Media Studies\n    * Creative Writing\n\n**Studying & Living Prices / Expenses:**\n\n**Tuition Fees:**\n\n* For Czech citizens and EU/EEA students: Free\n* For international students: \u20ac4,000-\u20ac15,000 per year\n\n**Living Expenses:**\n\n* Accommodation: \u20ac300-\u20ac500 per month\n* Food: \u20ac250-\u20ac350 per month\n* Transportation: \u20ac50-\u20ac70 per month\n* Other expenses: \u20ac100-\u20ac200 per month\n\n**Other Relevant Information:**\n\n* Charles University is the oldest and largest university in the Czech Republic, founded in 1348.\n* It is a research-intensive university with a strong focus on the humanities and social sciences.\n* The university has a beautiful campus located in the heart of Prague, a vibrant and historic city.\n* Charles University offers a wide range of student support services, including academic advising, career counseling, and housing assistance.\n* The university has a strong international reputation and attracts students from all over the world."
    ];

    const initialGoals = [
        {
            "major": "English Philology",
            "goals": [
                {
                    "title": "Year 1-2",
                    "description": "* Focus on developing strong writing and communication skills.\n* Take courses in literature, linguistics, and critical thinking.\n* Join a writing club or literary magazine.\n* Seek out opportunities to write for student publications or local newspapers."
                },
                {
                    "title": "Year 3-4",
                    "description": "* Continue to develop your writing skills by taking advanced courses in creative writing, journalism, or technical writing.\n* Choose a concentration in a specific area of English, such as literature, linguistics, or teaching.\n* Complete an internship at a publishing house, magazine, or newspaper."
                },
                {
                    "title": "Careers",
                    "entry": {
                        "title": "Entry-Level Positions",
                        "description": "* **Copywriter:** Write advertising and marketing materials. Median salary: €35,000 in Lithuania, €40,000 in Poland, €45,000 in the Czech Republic.\n* **Content Writer:** Create written content for websites, blogs, and social media. Median salary: €30,000 in Lithuania, €35,000 in Poland, €40,000 in the Czech Republic.\n* **Technical Writer:** Write technical documentation, such as manuals, white papers, and training materials. Median salary: €40,000 in Lithuania, €45,000 in Poland, €50,000 in the Czech Republic."
                    },
                    "mid": {
                        "title": "Mid-Level Positions",
                        "description": "* **Editor:** Edit and proofread written content. Median salary: €45,000 in Lithuania, €50,000 in Poland, €55,000 in the Czech Republic.\n* **Journalist:** Write news articles, feature stories, and other content for newspapers, magazines, and websites. Median salary: €40,000 in Lithuania, €45,000 in Poland, €50,000 in the Czech Republic.\n* **Public Relations Specialist:** Manage public relations campaigns and events. Median salary: €45,000 in Lithuania, €50,000 in Poland, €55,000 in the Czech Republic."
                    },
                    "senior": {
                        "title": "Senior-Level Positions",
                        "description": "* **Creative Director:** Oversee the creative direction of marketing and advertising campaigns. Median salary: €60,000 in Lithuania, €70,000 in Poland, €80,000 in the Czech Republic.\n* **Managing Editor:** Manage the editorial staff and oversee the production of written content. Median salary: €55,000 in Lithuania, €60,000 in Poland, €65,000 in the Czech Republic.\n* **Vice President of Communications:** Manage all aspects of corporate communications, including public relations, media relations, and employee communications. Median salary: €70,000 in Lithuania, €80,000 in Poland, €90,000 in the Czech Republic."
                    }
                }
            ]
        },
        {
            "major": "History",
            "goals": [
                {
                    "title": "Year 1-2",
                    "description": "* Focus on developing strong research and analytical skills.\n* Take courses in history, political science, and economics.\n* Join a history club or research group.\n* Seek out opportunities to conduct historical research or work on historical projects."
                },
                {
                    "title": "Year 3-4",
                    "description": "* Continue to develop your research skills by taking advanced courses in historiography, archival research, and historical methods.\n* Choose a concentration in a specific area of history, such as European history, American history, or Asian history.\n* Complete an internship at a museum, historical society, or government agency."
                },
                {
                    "title": "Careers",
                    "entry": {
                        "title": "Entry-Level Positions",
                        "description": "* **Archivist:** Preserve and manage historical documents and records. Median salary: €30,000 in Lithuania, €35,000 in Poland, €40,000 in the Czech Republic.\n* **Historian:** Research and write about the past. Median salary: €35,000 in Lithuania, €40,000 in Poland, €45,000 in the Czech Republic.\n* **Museum Curator:** Manage and interpret museum collections. Median salary: €40,000 in Lithuania, €45,000 in Poland, €50,000 in the Czech Republic."
                    },
                    "mid": {
                        "title": "Mid-Level Positions",
                        "description": "* **Historical Consultant:** Provide historical expertise to businesses, governments, and other organizations. Median salary: €45,000 in Lithuania, €50,000 in Poland, €55,000 in the Czech Republic.\n* **Museum Director:** Manage all aspects of a museum, including collections, exhibitions, and educational programs. Median salary: €50,000 in Lithuania, €55,000 in Poland, €60,000 in the Czech Republic.\n* **Public Historian:** Use history to inform public policy and decision-making. Median salary: €45,000 in Lithuania, €50,000 in Poland, €55,000 in the Czech Republic."
                    },
                    "senior": {
                        "title": "Senior-Level Positions",
                        "description": "* **Chief Historian:** Oversee the historical research and writing for an organization. Median salary: €60,000 in Lithuania, €70,000 in Poland, €80,000 in the Czech Republic.\n* **Executive Director of a Historical Society:** Manage all aspects of a historical society, including membership, fundraising, and programming. Median salary: €55,000 in Lithuania, €60,000 in Poland, €65,000 in the Czech Republic.\n* **University Professor of History:** Teach and conduct research in history at a university. Median salary: €60,000 in Lithuania, €70,000 in Poland, €80,000 in the Czech Republic."
                    }
                }
            ]
        },
        {
            "major": "Art History",
            "goals": [
                {
                    "title": "Year 1-2",
                    "description": "* Focus on developing strong analytical and writing skills.\n* Take courses in art history, art theory, and museum studies.\n* Visit museums and galleries regularly.\n* Write reviews or essays on art exhibitions."
                },
                {
                    "title": "Year 3-4",
                    "description": "* Continue to develop your research skills by taking advanced courses in art history historiography and methods.\n* Choose a concentration in a specific area of art history, such as Renaissance art, modern art, or contemporary art.\n* Complete an internship at a museum, art gallery, or auction house."
                },
                {
                    "title": "Careers",
                    "entry": {
                        "title": "Entry-Level Positions",
                        "description": "* **Art Gallery Assistant:** Assist with the day-to-day operations of an art gallery, including installing exhibitions, giving tours, and selling artwork. Median salary: €25,000 in Lithuania, €30,000 in Poland, €35,000 in the Czech Republic.\n* **Museum Educator:** Develop and deliver educational programs for museum visitors. Median salary: €30,000 in Lithuania, €35,000 in Poland, €40,000 in the Czech Republic.\n* **Art Archivist:** Preserve and manage art-related documents and records. Median salary: €35,000 in Lithuania, €40,000 in Poland, €45,000 in the Czech Republic."
                    },
                    "mid": {
                        "title": "Mid-Level Positions",
                        "description": "* **Art Curator:** Manage and interpret art collections. Median salary: €40,000 in Lithuania, €45,000 in Poland, €50,000 in the Czech Republic.\n* **Museum Registrar:** Manage the acquisition, storage, and display of museum objects. Median salary: €45,000 in Lithuania, €50,000 in Poland, €55,000 in the Czech Republic.\n* **Art Dealer:** Buy and sell artwork. Median salary: €50,000 in Lithuania, €55,000 in Poland, €60,000 in the Czech Republic."
                    },
                    "senior": {
                        "title": "Senior-Level Positions",
                        "description": "* **Museum Director:** Manage all aspects of a museum, including collections, exhibitions, and educational programs. Median salary: €60,000 in Lithuania, €70,000 in Poland, €80,000 in the Czech Republic.\n* **Chief Curator:** Oversee the curatorial staff and collections of a museum or art gallery. Median salary: €70,000 in Lithuania, €80,000 in Poland, €90,000 in the Czech Republic.\n* **Art Historian:** Teach and conduct research in art history at a university. Median salary: €60,000 in Lithuania, €70,000 in Poland, €80,000 in the Czech Republic."
                    }
                }
            ]
        }
    ];

    useEffect(() => {
        setInitialNodes([]);
        setTimeout(() => {
            //AlignNodesNicely(20, 50);
            addButtons();
        }, 1000);
    }, [Props]);

    if(goalsProp.length === 0){ // if goals is empty
        goals = initialGoals;
    } else { goals = goalsProp; }
    if(Object.keys(universityRecommendationsProp).length === 0){ // if universityRecommendations is empty
        universityRecommendations = initialUniversityRecommendations;
    } else {
        universityRecommendations = universityRecommendationsProp;
    }   

    var majors = [];
    var initialNodesFirst = [];
    for (let i = 0; i < universityRecommendations.length; i++) {
        initialNodesFirst.push({
            id: i.toString(),
            data: { label: <Markdown remarkPlugins={[remarkGfm]}>{universityRecommendations[i]}</Markdown> },
            position: { x: (i * 820), y: 0},
            dragable: true,
            className: "node recommendation",
            nodeType: "university"
        });

        majors.push(goals[i]['major']);

        for (let j = 0; j < goals[i]['goals'].length; j++) {
            const currentGoals = goals[i]['goals'][j];
            const goalTitle = currentGoals.title;

            if(goalTitle.toUpperCase() == "CAREERS" || goalTitle.toUpperCase() == "CAREER"){
                initialNodesFirst.push({
                    id: i + "-" + j,
                    data: { label: <><Markdown remarkPlugins={[remarkGfm]}>{goalTitle + " (" + majors[i] + ") " + "\n\n" + currentGoals.entry.title + "\n\n" + currentGoals.entry.description + "\n\n" + currentGoals.mid.title + "\n\n" + currentGoals.mid.description + "\n\n" + currentGoals.senior.title + "\n\n" + currentGoals.senior.description}</Markdown> </> }, /*<a href="#" onClick={() => tryGetJobLink(currentGoals, majors[i])}>Gauti rekomendacijų</a>*/
                    position: { x: 0 + (i * 820), y: -600},
                    dragable: true,
                    className: "node career",
                    nodeType: "career"
                });
            } else {
                initialNodesFirst.push({
                    id: i + "-" + j,
                    data: { label: <Markdown remarkPlugins={[remarkGfm]}>{goalTitle + " (" + majors[i] + ") " + "\n\n" + currentGoals.description}</Markdown> },
                    position: { x: 0 + (i * 820), y: 800 + (j * 200)},
                    dragable: true,
                    className: "node goal goal-" + i,
                    nodeType: "goal"
                });
            }
        }
    }

    function addButtons() {
        for (let i = 0; i<initialNodesFirst.length; i++) {
            var content = "";

            if(initialNodesFirst[i].nodeType === "goal" || initialNodesFirst[i].nodeType === "career"){
                const goalID = initialNodesFirst[i].id.split("-")[0];
                content = goals[goalID]
            } else if(initialNodesFirst[i].nodeType === "university"){
                content = universityRecommendations[initialNodesFirst[i].id];
            }

            initialNodesFirst[i].data.label =
            <div>{initialNodesFirst[i].data.label}
                <ReportBar nodeType={initialNodesFirst[i].nodeType} QnA={QnA} content={content}
                />
            </div>;
        }
    }

    if(initialNodes.length === 0){
        addButtons();
        setInitialNodes(initialNodesFirst);
    }

    /*
    for (let i = 0; i < careerRecommendations.length; i++) {
        initialNodes.push({
            id: (i + universityRecommendations.length).toString(),
            data: { label: <Markdown remarkPlugins={[remarkGfm]}>{careerRecommendations[i]}</Markdown> },
            position: { x: i * 500, y: 600 },
            dragable: true,
            className: "university career",
        });
    }

    // Create edges between university every career recommendation
    for (let i = 0; i < universityRecommendations.length; i++) {
        for (let j = 0; j < careerRecommendations.length; j++) {
            initialEdges.push({
                id: "e" + i + "-" + j,
                source: i.toString(),
                target: (j + universityRecommendations.length).toString(),
            });
        }
    }*/
    const onLoad = (reactFlowInstance) => {
        reactFlowInstance.fitView();
    };

    return (
        ifMobile() ? 
        <>
            <div className="line"></div>
            {initialNodes.map((node, index) => (
                <>
                <div className={node.className}>
                    {node.data.label}
                </div>
                {node.nodeType === "career" ? <div className="line" /> : null}
                </>
            ))}
        </> : (
        <>
            <ReactFlow 
                ref={reactFlowWrapper}
                nodes={initialNodes} 
                //edges={initialEdges} 
                //onNodeClick={openRecommendation}
                panOnDrag={true}
                nodesDraggable={false}
                zoomOnScroll={true}
                defaultViewport={{ x: 40, y: 20, zoom: 0.6}}
                onLoad={onLoad} 
                maxZoom={1}
                minZoom={0.4}
                >
                <Controls />
            </ReactFlow>
            <button id="testBtn" onClick={() => AlignNodesNicely(20, 50)}>Align nodes (zoom in and press this if there's a bug)</button>
        </> )
    );
};

export default MindMap;